module.exports = __webpack_public_path__ + "static/media/carousalThree.d49076e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/carousalThree.jpg
// module id = 60
// module chunks = 0